export const scrollBottom = (element) => {
    element.scrollTop = element.scrollHeight + 10
}